__turbopack_context__.v({
  "className": "open_sans_99f74ff2-module___JUnBa__className",
  "variable": "open_sans_99f74ff2-module___JUnBa__variable",
});
